function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 60.338h362.023v241.346H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#338af3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 60.338h362.023v30.168H0zm0 60.341h362.023v30.168H0zm0 60.335h362.023v30.168H0zm0 60.336h362.023v30.168H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 60.338h133.788v120.676H0z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#f0f0f0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 107.27h133.788v26.814H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.487 60.338h26.814v120.676H53.487z"
}));

const SvgGreece = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 362.023 362.023",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGreece, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/greece.8701f2df.svg";
export { ForwardRef as ReactComponent };